/**
 * Widerrufsformular — Uhrinstinkt
 * Datei: assets/widerruf-form.js
 *
 * Verantwortlich für:
 * - Client-Validierung (Pflichtfelder + E-Mail-Format)
 * - Spam-Schutz via Honeypot
 * - Submit als JSON an das AWS-Lambda (Endpoint aus data-endpoint)
 * - Loading-/Erfolgs-/Fehler-Handling
 *
 * Das Lambda erstellt das Zendesk-Ticket (requester = Kunde) und sorgt
 * für die 1:1-Kopie an den Kunden. Hier liegt KEIN Zendesk-Token.
 *
 * Alle sichtbaren Texte kommen aus data-*-Attributen (zweisprachig via Liquid).
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('widerrufForm');
    if (form) {
      new WiderrufForm(form);
    }
  });

  function WiderrufForm(form) {
    this.form = form;
    this.endpoint = form.getAttribute('data-endpoint') || '';
    this.locale = form.getAttribute('data-locale') || '';

    this.messages = {
      required: form.getAttribute('data-msg-required') || '',
      email: form.getAttribute('data-msg-email') || '',
      error: form.getAttribute('data-msg-error') || '',
      sending: form.getAttribute('data-msg-sending') || ''
    };

    this.submitButton = document.getElementById('wfSubmit');
    this.submitLabel = this.submitButton && this.submitButton.querySelector('.wf__submit-label');
    this.defaultSubmitText = this.submitLabel ? this.submitLabel.textContent : '';

    this.errorBox = document.getElementById('wfError');
    this.overlayId = form.getAttribute('data-overlay') || 'widerrufSuccess';

    this.requiredFields = ['vorname', 'nachname', 'bestellnummer', 'email'];

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  // ---------------------------------------------------------
  // SUBMIT
  // ---------------------------------------------------------

  WiderrufForm.prototype.handleSubmit = function (evt) {
    evt.preventDefault();
    this.clearError();

    // Honeypot: ausgefüllt => Bot => still verwerfen (so tun als ob gesendet)
    var honeypot = this.form.querySelector('[name="website"]');
    if (honeypot && honeypot.value.trim() !== '') {
      this.showSuccess(null);
      return;
    }

    var data = this.collectData();

    var validationError = this.validate(data);
    if (validationError) {
      this.showError(validationError);
      return;
    }

    this.submit(data);
  };

  WiderrufForm.prototype.collectData = function () {
    var fd = new FormData(this.form);
    function val(name) {
      var v = fd.get(name);
      return v == null ? '' : String(v).trim();
    }
    return {
      anrede: val('anrede'),
      vorname: val('vorname'),
      nachname: val('nachname'),
      strasse: val('strasse'),
      plz: val('plz'),
      ort: val('ort'),
      bestellnummer: val('bestellnummer'),
      bestelldatum: val('bestelldatum'),
      lieferdatum: val('lieferdatum'),
      mitteilung: val('mitteilung'),
      email: val('email')
    };
  };

  WiderrufForm.prototype.validate = function (data) {
    for (var i = 0; i < this.requiredFields.length; i += 1) {
      var key = this.requiredFields[i];
      if (!data[key]) {
        return this.messages.required;
      }
    }
    // einfache, robuste E-Mail-Prüfung
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email);
    if (!emailOk) {
      return this.messages.email;
    }
    return null;
  };

  WiderrufForm.prototype.submit = function (data) {
    var self = this;

    if (!this.endpoint) {
      this.showError(this.messages.error);
      return;
    }

    this.setLoading(true);

    var payload = {
      formType: 'widerruf',
      locale: this.locale,
      source: window.location.href,
      data: data
    };

    fetch(this.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('HTTP ' + response.status);
        }
        return response.json().catch(function () {
          return {};
        });
      })
      .then(function (result) {
        self.showSuccess(result);
      })
      .catch(function () {
        self.setLoading(false);
        self.showError(self.messages.error);
      });
  };

  // ---------------------------------------------------------
  // UI-STATE
  // ---------------------------------------------------------

  WiderrufForm.prototype.setLoading = function (isLoading) {
    if (!this.submitButton) return;
    if (isLoading) {
      this.submitButton.disabled = true;
      this.submitButton.classList.add('is-loading');
      if (this.submitLabel && this.messages.sending) {
        this.submitLabel.textContent = this.messages.sending;
      }
    } else {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('is-loading');
      if (this.submitLabel) {
        this.submitLabel.textContent = this.defaultSubmitText;
      }
    }
  };

  WiderrufForm.prototype.showError = function (message) {
    if (!this.errorBox) return;
    this.errorBox.textContent = message;
    this.errorBox.hidden = false;
  };

  WiderrufForm.prototype.clearError = function () {
    if (!this.errorBox) return;
    this.errorBox.hidden = true;
    this.errorBox.textContent = '';
  };

  WiderrufForm.prototype.showSuccess = function (result) {
    var ticketId = result && (result.ticketId || result.ticket_id || result.reference);

    // Gemeinsames Erfolgs-Overlay öffnen (Fokus/Scroll-Lock via form-kit.js)
    if (window.FormKit && typeof window.FormKit.openOverlay === 'function') {
      window.FormKit.openOverlay(this.overlayId, ticketId);
    }

    // Formular im Hintergrund zurücksetzen
    this.form.reset();
    this.setLoading(false);
  };
})();
